export default "__VITE_ASSET__Ca66vJlx__"